module.exports = __webpack_public_path__ + "img/poly-9.2c008d0d.png";